import { Component, inject } from '@angular/core';
import {AuthentificationService} from "../../../core/services/authentification.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-homepage',
    template: ''
})
export class HomepageComponent {
    private authService = inject(AuthentificationService);
    private router = inject(Router);


    constructor() {
        this.redirectAccordingToRole();
    }

    private redirectAccordingToRole() {
        if (
            this.authService.isAdmin()
            || this.authService.isDataVis()
            || this.authService.isPresident()
            || this.authService.isAssociate()
        ) {
            this.router.navigate(['/datavis/dashboard']);
            return;
        }

        if (this.authService.hasRoleExpert()) {
            this.router.navigate(['/dossiers/mes-expertises']);
            return;
        }

        this.router.navigate(['/accueil']);
    }
}
